module.exports = __webpack_public_path__ + "static/media/recette.09d90066.png";


//////////////////
// WEBPACK FOOTER
// ./src/res/entries/recette.png
// module id = 1082
// module chunks = 0